import(/* webpackMode: "eager" */ "/app/src/app/software-development/layout.js");
